import * as React from 'react';
import { DataGrid } from '@material-ui/data-grid';
import Chip from '@material-ui/core/Chip';
import Typography from '@material-ui/core/Typography'


function ChangeColor({value, changePercentColor} :any) {
  return(
    <div style={{ color: changePercentColor }}>
      <Typography>{ value }</Typography>
    </div>
  );
}



function CompanyListDataGrid({data} :any) {

  function truncateStr(str, n){
    return (str.length > n) ? str.substr(0, n-1) + '...' : str;
  };


  function recommendationClass(decision) {
    if (decision == 'Overvalued') {
      return <Chip label="Sell" color="secondary"/>
    } else if (decision == 'Undervalued') {
      return <Chip label="Buy" color="primary"/>
    } else if (decision == 'Unpredictable') {
      return <Chip label="Don't Buy" color="secondary"/>
    } else if (decision == 'Undetermined') {
      return <Chip label="Don't Buy" color="secondary"/>
    } else {
      return <Chip label="Hold" color="default"/>
    }
  }

  function tableRowClass(decision_color) {
    if (decision_color == 'red') {
      return 'table-danger'
    } else if (decision_color == 'green') {
      return 'table-success'
    } else if (decision_color == null) {
      return 'table-danger'
    } else {
      return 'table-secondary'
    }
  }


  const columns = [
    { field: 'id', headerName: 'Ticker', width: 80, sortable: false, renderHeader:(params) => ( <strong>Ticker</strong>), renderCell: (params) => (<a target="_blank" rel="noopener noreferrer" href={"/ticker/" + params.value}><strong>{params.value}</strong></a>)},
    { field: 'company', headerName: 'Company', width: 200, sortable: false, renderHeader:(params) => ( <strong>Company</strong>)},
    { field: 'industry', headerName: 'Industry', width: 250, renderHeader:(params) => ( <strong>Industry</strong>)},
    { field: 'valueScore', headerName: 'Value Score', width: 127, renderHeader:(params) => ( <strong>Value Score</strong>)},
    { field: 'consideration', headerName: 'Consideration', width: 150, renderHeader:(params) => ( <strong>Consideration</strong>)},
    { field: 'decision', headerName: 'Decision', width: 180, renderHeader:(params) => ( <strong>Decision</strong>)},
    { field: 'price', headerName: 'Price',  width: 100, renderHeader:(params) => ( <strong>Price</strong>), renderCell: (params) => (< ChangeColor value={params.value} changePercentColor={ params.getValue(params.id, 'changePercentColor') } /> )},
    { field: 'changePercent', headerName: 'changePercent', width: 100, renderHeader:(params) => ( <strong>Change</strong>), renderCell: (params) => (< ChangeColor value={params.value} changePercentColor={ params.getValue(params.id, 'changePercentColor') } /> )},
    { field: 'marginOfSafety', headerName: 'Margin of Safety', sortable: false,  width: 180, renderHeader:(params) => ( <strong>Margin of Safety</strong>)},
    { field: 'paybackTime', headerName: 'Payback Time', width: 150, renderHeader:(params) => ( <strong>Payback Time</strong>), renderCell: (params) => (params.value ? (params.value + ' years') : 'unpredictable')},
    { field: 'recommendationColor', hide: true},
    { field: 'changePercentColor', hide: true}
  ]

  function buildCompanyData(item) {
    return {
      id: item.ticker,
      company: item.company,
      industry: item.industry,
      price: item.default_valuation?.price_in_words,
      changePercent: item.quote?.change_percent,
      consideration: item.default_valuation?.recommendation || "Don't Buy",
      decision: item.default_valuation?.decision || 'Undetermined',
      marginOfSafety: item.default_valuation?.margin_of_safety_in_words,
      paybackTime: (item.default_valuation?.payback_time?.current_payback_time_number),
      valueScore: item.value_score,
      recommendationColor: item.default_valuation?.recommendation_color,
      changePercentColor: item.quote?.change_percent_color
    }
  }

  const rows = data?.map(item => buildCompanyData(item));

  return (
    <div className="row">
      <DataGrid
        rows={rows}
        columns={columns}
        pageSize={30}
        rowsPerPageOptions={[30]}
        autoHeight={true}
        autoPageSize={true}
        density={"compact"}
        disableColumnMenu
        getRowClassName={(params) =>
          (tableRowClass(params.getValue(params.id, 'recommendationColor')))
        }
      />
    </div>
  );
}

export default CompanyListDataGrid;
